/**
 * The app's mark for a person: an orb and nothing in it, its colour chosen
 * from the name. The same hash and the same eight colours as the admin app's
 * PersonMark (hireos-intake admin/src/components/inbox/PersonMark.tsx), so a
 * name on this page is the orb it is in the product. The receptionist has her
 * own blue and green, which no name picks.
 */

const TONES = ["clay", "sage", "ochre", "slate", "rose", "moss", "heather", "tide"] as const;
type Tone = (typeof TONES)[number] | "receptionist";

/** A name's colour: the same name, however it is spaced or cased, is always the same one. */
export function toneOf(name: string): Tone {
  // FNV-1a: a plain sum leaves the low bits, which pick the tone, alike.
  let h = 0x811c9dc5;
  for (const c of name.trim().toLowerCase().replace(/\s+/g, " "))
    h = Math.imul(h ^ c.codePointAt(0)!, 0x01000193) >>> 0;
  return TONES[((h ^ (h >>> 16)) >>> 0) % TONES.length]!;
}

export function Orb({
  name,
  tone,
  size,
  className = "",
}: {
  name?: string;
  tone?: Tone;
  /** In px; left out, the stylesheet sizes it. */
  size?: number;
  className?: string;
}) {
  return (
    <span
      className={`orb ${className}`.trim()}
      data-tone={tone ?? toneOf(name ?? "")}
      style={size ? { width: size, height: size } : undefined}
      aria-hidden="true"
    />
  );
}

export function ReceptionistOrb(props: { size?: number; className?: string }) {
  return <Orb tone="receptionist" {...props} />;
}
